DealsPaginationFooterView = require './pagination_footer'
DealsPaginationEventsHelper = require '../helpers/pagination_events'
PaginatedDealsListTemplate = require '../../paginated_deals_list.html.mustache'

module.exports = class PaginatedDealsListView
  template: PaginatedDealsListTemplate
  dealsListId: 'browse-deals'

  constructor: (@$el, @dealSearch) ->
    @$content = @$el.find('.content')
    @prevSearch = null

    @footer = new DealsPaginationFooterView()
    @footer.on 'click:paginationLink', @paginationClickHandler

    currentSearchPage = @dealSearch.params.page ? 1
    window.onpopstate = _.partial(DealsPaginationEventsHelper.popStateHandler, currentSearchPage)

  render: ->
    return if @dealSearch.isEmptySearch()

    @$content.html @toHtml()
    @postRender()

    Groupon.BrowseTracking.pageReady()

  postRender: (overwriteExisting = true) ->
    @footer
      .updatePresenter(@dealSearch)
      .setElement(@$el.find('.pagination_footer'))
    @footer.render() if overwriteExisting

    GIG.Utils.truncateElements(element = @$content, options = { watch: false })
    GIG.Tooltip.reloadBindings(element = @$content, false)

  toHtml: ->
    @template.render(@present())

  present: ->
    hash = _.extend {}, @dealSearch.page, {
      @dealsListId
      columnLayoutClass: Groupon.columnLayoutClass
      cardUIClass: Groupon.cardUIClass
      clearanceWidget: @dealSearch.params?.discount == "gg-clearance" and Groupon.showClearanceWidget
    }
    hash

  searchSuccess: =>
    @$content.find("##{@dealsListId}").append @dealSearch.page.dealsHtml
    @postRender()

  searchError: =>
    @dealSearch = @prevSearch
    @footer.removeLoadingState()
    @$el.find('.pagination_footer').remove()

  paginationClickHandler: (event) ->
    DealsPaginationEventsHelper.updatePageByHref(event.target.href)
